import React, { useState } from "react";
import axios from "axios";
import {
  Dialog,
  DialogContent,
  Button,
  TextField,
  Typography,
  IconButton,
  Box,
  Grid,
  InputAdornment,
  Alert,
  Fade,
  useTheme,
  useMediaQuery,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import DescriptionIcon from "@mui/icons-material/Description";

export default function ModalDescripcion({ actualizarTabla }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [open, setOpen] = useState(false);
  const [descripcion, setDescripcion] = useState("");
  const [codigo, setCodigo] = useState("");
  const [foto, setFoto] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const API_GUARDAR = "https://demo.datachile.site/API/web/guardar_descripcion.php";

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setDescripcion("");
    setCodigo("");
    setFoto(null);
    setError("");
  };

  const guardarDescripcion = async (e) => {
    e.preventDefault();
    if (!descripcion) return setError("Debe ingresar descripción");

    const data = new FormData();
    data.append("descripcion", descripcion);
    data.append("codigo", codigo);
    if (foto) data.append("foto_generica", foto);

    try {
      setLoading(true);
      await axios.post(API_GUARDAR, data, { headers: { "Content-Type": "multipart/form-data" } });
      actualizarTabla();
      handleClose();
    } catch (err) {
      console.error(err);
      setError("Error al guardar descripción");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button
        variant="contained"
        onClick={handleOpen}
        sx={{ borderRadius: 2, px: 3, background: "linear-gradient(90deg, #1976d2, #42a5f5)" }}
      >
        Agregar Descripción
      </Button>

      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="md"
        fullScreen={isMobile}
        TransitionComponent={Fade}
        PaperProps={{ sx: { borderRadius: isMobile ? 0 : 4 } }}
      >
        {/* HEADER */}
        <Box sx={{ px: 4, py: 3, display: "flex", justifyContent: "space-between", alignItems: "center", background: "linear-gradient(90deg, #1976d2, #42a5f5)", color: "white" }}>
          <Typography variant="h6">Nueva Descripción</Typography>
          <IconButton onClick={handleClose} sx={{ color: "white" }}><CloseIcon /></IconButton>
        </Box>

        <form onSubmit={guardarDescripcion}>
          <DialogContent dividers sx={{ p: 4, overflowY: "auto" }}>
            {error && <Alert severity="error">{error}</Alert>}

            <Grid container spacing={3}>
              <Grid item xs={12} md={8}>
                <TextField
                  label="Descripción"
                  fullWidth
                  value={descripcion}
                  onChange={(e) => setDescripcion(e.target.value)}
                  InputProps={{ startAdornment: <InputAdornment position="start"><DescriptionIcon /></InputAdornment> }}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField label="Código" fullWidth value={codigo} onChange={(e) => setCodigo(e.target.value)} />
              </Grid>
              <Grid item xs={12}>
                <Button variant="contained" component="label">
                  Subir foto
                  <input type="file" hidden onChange={(e) => setFoto(e.target.files[0])} />
                </Button>
              </Grid>
            </Grid>

            <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 4 }}>
              <Button onClick={handleClose} variant="outlined" fullWidth={isMobile}>Cancelar</Button>
              <Button type="submit" variant="contained" fullWidth={isMobile} disabled={loading} sx={{ background: "linear-gradient(90deg, #1976d2, #42a5f5)" }}>
                {loading ? "Guardando..." : "Guardar"}
              </Button>
            </Box>
          </DialogContent>
        </form>
      </Dialog>
    </>
  );
}